export default __webpack_public_path__ + "static/media/image.9ea83da6.jpg";